import $ from 'jquery';
import { normalize } from '../utilities/normalize';
import { escapeRegExp } from '../utilities/escaperegexp';

$(document).ready(function() {
  if (!$('.path-search-infrastructure-priority-list').length) {
    return;
  }

  const iplMap = $('.ipl-map');
  const mapCover = $('.ipl-map-cover');
  const mapTab = $('.ipl-map li[role="tab"]');
  const mapNationalButton = $('.ipl-map .map-national');
  const mapFilterOption = $(
    '.map-filter li.facet-item, .map-filter .identified-checkbox'
  );
  const mapFilterIdentifiedCheckbox = $('.map-filter .identified-checkbox');
  const mapClearAllButton = $('.map-clear-all-button');
  const mapSearchKey = $('.ipl-map #map-search-key');
  const listSearchKey = $('.ipl-map .list-view #list-search-key');
  const listSearchIcon = $('.ipl-map .list-view #list-search-icon');
  const listSearchClear = $('.ipl-map .list-view #list-search-clear');
  const mapListViewContent = $('.ipl-map .list-view .view-content');
  const mapListViewSearchContent = mapListViewContent.find('.search__content');
  const mapListViewPager = $('.ipl-map .list-view .pager');
  const mapListViewPagerUl = mapListViewPager.find('.pager__items');
  const projectsShownOnPage = 100;
  const listFilterSummaryNo = $('.ipl-map .filter-summary .project-total-no');
  const listFilterSummaryList = $('.ipl-map .filter-summary .selected-filter');
  const listFilterFacetItemList = $('.ipl-map .filter-summary .selected-facet-items');
  const listViewTab = $('.ipl-map #tab1');
  let searchResult = "";
  if ( $('.hidden-header')[0] && $('.hidden-header')[0]!=="undefined") {
    searchResult = $('.hidden-header')[0].innerHTML;
  }

   $( ".list-view .views-row" ).each(function() {
    if ($(this)[0]!=="undefined" && $(this).find('.timestamp-hidden')[0] && $(this).find('.timestamp-hidden')[0]!=="undefined") {
      if ($(this).find('.timestamp-hidden')[0].innerHTML.includes('year') === false ){
        $(this).find('.search__info').append('<div class="search-item-new"><p>New</p></div>');
      }
  }
});

  // remove all map button accessibility
  $('.mapboxgl-control-container button').attr('tabindex', '-1');
  $('.mapboxgl-canvas').attr('tabindex', '-1');

  $('.ipl-map .filter-summary .view-filter-summary').after('<div class="noresult" style="display:none">No results found</div>');

  // listViewTab.on('click', function() {
  //   if (mapSearchKey.val()) {
  //     listSearchKey.val(mapSearchKey.val());
  //   }
  // });
  updateListPager();




  mapCover.on('click', function() {
    $(this).addClass('hidden');
  });
  mapCover.on('keydown', function() {
    $(this).trigger('click');
  });

  mapTab.on('click', function() {
    $(this)
      .siblings()
      .attr('aria-selected', 'false');
    $(this).attr('aria-selected', 'true');
    const tabpanid = $(this).attr('aria-controls');
    $(this)
      .parent()
      .siblings('[role="tabpanel"]')
      .css("display","none")
      .attr('aria-hidden', 'true')
      .find('a')
      .attr('tabindex', '-1');
    $('#' + tabpanid)
      .attr('aria-hidden', 'false')
      .css("display","block")
      .find('a')
      .attr('tabindex', '0');
    iplMap.attr('data-tab', $('#' + tabpanid).attr('class'));

    if (tabpanid == 'panel2') {
      resetStateFilter();
    } else {
      disableRegionFilter();
    }
    // updateListBySearchAndFilter();
      updateListPager();
  });

  mapTab.on('keydown', function(e) {
    const key = e.keyCode ? e.keyCode : e.which;
    if (key == 13) {
      $(this).trigger('click');
    }
  });

  mapFilterOption.on('click', 'label', function(e) {
    e.preventDefault();
    const isChecked = !$(this)
      .prev()
      .attr('checked');
    $(this)
      .prev()
      .attr('checked', isChecked);

    if ($('.ipl-map').attr('data-tab') == 'list-view') {
      // state and region filter control
      if (
        $(this)
          .prev()
          .attr('data-filter') == 'state'
      ) {
        const stateValue = $(this)
          .prev()
          .attr('data-value');

        $('.block-facets input[data-filter="region"]').each(function() {
          if ($(this).attr('data-state') == stateValue && isChecked) {
            $(this)
              .parent()
              .show();
          } else if ($(this).attr('data-state') == stateValue && !isChecked) {
            $(this)
              .parent()
              .hide();
            $(this).removeAttr('checked');
          }
        });
        $('.region-filter .item-list__checkbox').css('height', 'auto');
        if (
          $('.state-filter input[checked="checked"][data-filter!="national"]')
            .length &&
          $('.region-filter input[data-state="' + stateValue + '"]').length
        ) {
          enableRegionFilter();
        } else {
          disableRegionFilter();
        }
      }

      // national filter control
      if (
        $(this)
          .prev()
          .attr('data-filter') == 'national'
      ) {
        if (
          $(this)
            .prev()
            .attr('checked')
        ) {
          disableAllState();
          disableRegionFilter();
        } else {
          enableAllState();
        }
      }

      // update list view
      // updateListBySearchAndFilter();
        updateListPager();
    }
  });

  mapFilterOption.on('keydown', 'input', function(e) {
    const key = e.keyCode ? e.keyCode : e.which;
    if (key == 13 || key == 32) {
      $(this)
        .next()
        .click();
    }
  });

  mapFilterIdentifiedCheckbox
    .attr('tabindex', '0')
    .find('input')
    .attr('tabindex', '-1');
  mapFilterIdentifiedCheckbox.on('keydown', function(e) {
    const key = e.keyCode ? e.keyCode : e.which;
    if (key == 13 || key == 32) {
      $(this)
        .find('label')
        .click();
    }
  });

  mapNationalButton.hover(function() {
    $(this)
      .parent()
      .toggleClass('national-hovered');
  });

  mapNationalButton.on('click', function() {
    $('.ipl-map #tab1').click();
    $('.state-filter input[data-value="national"]')
      .next()
      .click();
  });

  // mapClearAllButton.on('click', function() {
  //   if ($('.ipl-map').attr('data-tab') == 'list-view') {
  //     $('.map-filter input.facets-checkbox[checked="checked"]').removeAttr(
  //       'checked'
  //     );
  //     listSearchKey.val('');
  //     listSearchKey.removeClass('hasValue');
  //     enableAllState();
  //     disableRegionFilter();
  //     updateListBySearchAndFilter();
  //   }
  // });

  // listSearchKey.keyup(function(e) {
  //   if (e.which == 13) {
  //     // updateListBySearchAndFilter();
  //   }

  //   if (listSearchKey.val()) {
  //     listSearchKey.addClass('hasValue');
  //   } else {
  //     listSearchKey.removeClass('hasValue');
  //     updateListBySearchAndFilter();
  //   }
  //   updateListViewClearAllButtonStatus();
  // });

  // listSearchIcon.on('click', function() {
  //   updateListBySearchAndFilter();
  // });

  // listSearchClear.on('click', function() {
  //   listSearchKey.val('');
  //   listSearchKey.removeClass('hasValue');
  //   updateListBySearchAndFilter();
  // });

  // add pager click handler
  mapListViewPager.on('click', '.pager__item', function() {
    if ($(this).hasClass('pager__item--previous')) {
      if ($(this).hasClass('clickable')) {
        $(this)
          .siblings('.is-active')
          .prev()
          .click();
      }
    } else if ($(this).hasClass('pager__item--next')) {
      if ($(this).hasClass('clickable')) {
        $(this)
          .siblings('.is-active')
          .next()
          .click();
      }
    } else {
      $(this)
        .siblings()
        .removeClass('is-active');
      $(this).addClass('is-active');
      const page = $(this).attr('data-page');
      mapListViewContent.attr('data-page', 'page-' + page);
      const mapListViewPagerPrev = mapListViewPager.find(
        '.pager__item--previous'
      );
      const mapListViewPagerNext = mapListViewPager.find('.pager__item--next');
      if (!mapListViewPagerPrev.next().hasClass('is-active')) {
        mapListViewPagerPrev.addClass('clickable');
      } else {
        mapListViewPagerPrev.removeClass('clickable');
      }
      if (!mapListViewPagerNext.prev().hasClass('is-active')) {
        mapListViewPagerNext.addClass('clickable');
      } else {
        mapListViewPagerNext.removeClass('clickable');
      }
    }

    $('html, body').animate(
      {
        scrollTop: $('#ipl-map').offset().top,
      },
      800
    );

    updateListPagerDisplay();
  });

  mapListViewPager.on('keydown', 'a', function(e) {
    const key = e.keyCode ? e.keyCode : e.which;
    if (key == 13) {
      $(this)
        .parent()
        .click();
    }
  });

  function updateListBySearchAndFilter() {
    updateListViewClearAllButtonStatus();

    const searchKeyword = normalize(listSearchKey.val());
    const identifiedValue =
      $('.map-filter .identified-checkbox input').attr('checked') == 'checked'
        ? 'yes'
        : 'no';
    const filterData = {
      state: [],
      region: [],
      sector: [],
      national: [],
    };
    let allSelectedFilter = '';
    let allSelectedFacetItems = '';
    let searchContentAndTags = '';
    // $('.map-filter li.facet-item input.facets-checkbox').each(function() {
    //   if (searchResult ==''){
    //   if ($(this).attr('checked') == 'checked') {
    //     const filterValue = $(this)
    //       .next()
    //       .find('span')
    //       .text();
    //     allSelectedFilter == ''
    //       ? (allSelectedFilter += filterValue)
    //       : (allSelectedFilter += ', ' + filterValue);
    //     filterData[$(this).attr('data-filter')].push(filterValue.toLowerCase());
    //   }
    // }else {
    //     if ($(this).attr('checked') == 'checked') {
    //       const filterValue = $(this)
    //         .next()
    //         .find('span')
    //         .text();
    //       searchContentAndTags= '"' + searchResult + '"' + ', ' + filterValue;
    //       allSelectedFilter == ''
    //         ? (allSelectedFilter += searchContentAndTags)
    //         : (allSelectedFilter += ', ' + filterValue);
    //   }
    // }
    // });
    // if (searchResult !=='' && allSelectedFilter == ''){
    //   allSelectedFilter = '"' + searchResult + '"';
    // }
    // if (allSelectedFilter == '') {
    //   allSelectedFilter = 'All';
    // }

    //update the summary block
    if (searchResult ==''){
        allSelectedFilter == '';
    }else {
        allSelectedFilter =  '"' + searchResult.replace(/\s+/g, '" "') + '"' ;
    }
    if (allSelectedFilter == '') {
      allSelectedFilter = 'Nil';
    }

    $('.map-filter li.facet-item input.facets-checkbox').each(function() {
      if ($(this).attr('checked') == 'checked') {
        const filterValue = $(this)
          .next()
          .find('span')
          .text();
        allSelectedFacetItems == ''
          ? (allSelectedFacetItems += filterValue)
          : (allSelectedFacetItems += ', ' + filterValue);
     }
    });

    if (allSelectedFacetItems == '') {
      allSelectedFacetItems = 'All';
    }
    let projectNo = 0;
    mapListViewSearchContent.each(function() {
      const states = normalize($(this).attr('data-state')).split(',');
      const isInState =
        filterData.state.length == 0 ||
        hasSameElement(filterData.state, states);
      const regions = normalize($(this).attr('data-region')).split(',');
      const isInRegion =
        filterData.region.length == 0 ||
        hasSameElement(filterData.region, regions);
      const sectors = normalize($(this).attr('data-sector')).split(',');
      const isInSector =
        filterData.sector.length == 0 ||
        hasSameElement(filterData.sector, sectors);
      const isIdentified =
        identifiedValue == 'no' ||
        $(this).attr('data-identified') == identifiedValue;
      const isNational = $(this).attr('data-national') == 'yes';
      let isMatchingKeyword = true;

      if (searchKeyword.length) {
        const searchExp = new RegExp(
          `\\b(${escapeRegExp(normalize(searchKeyword))})\\b`,
          'gim'
        );
        const title = normalize(
          $(this)
            .find('.field--name-node-title a')
            .text()
        );
        const containTitle = searchExp.test(title);
        const summary = normalize(
          $(this)
            .find('.field--type-text-with-summary')
            .text()
        );
        const containSummary = searchExp.test(summary);
        const projectType = normalize(
          $(this)
            .find('.field--type-project-type')
            .text()
        );
        // Use escapeRegExp for regexp
        // Do a precise match for containsProjectType
        const containsProjectType = searchExp.test(projectType);
        isMatchingKeyword =
          containTitle || containSummary || containsProjectType;
      }

      if (filterData.national.length) {
        // if national option is selected
        if (isNational && isInSector && isIdentified && isMatchingKeyword) {
          $(this)
            .closest('.views-row')
            .removeClass('hidden')
            .attr('data-page', Math.floor(projectNo / projectsShownOnPage) + 1);
          projectNo++;
        } else {
          $(this)
            .closest('.views-row')
            .addClass('hidden')
            .removeAttr('data-page');
        }
      } else {
        // if national option is not selected
        if (
          isInState &&
          isInRegion &&
          isInSector &&
          isIdentified &&
          isMatchingKeyword
        ) {
          $(this)
            .closest('.views-row')
            .removeClass('hidden')
            .attr('data-page', Math.floor(projectNo / projectsShownOnPage) + 1);
          projectNo++;
        } else {
          $(this)
            .closest('.views-row')
            .addClass('hidden')
            .removeAttr('data-page');
        }
      }
    });

    if(projectNo == 0) {
      $(".noresult").show();
      $('.ipl-map .filter-summary .view-filter-summary').hide();
    }
    else {
      $(".noresult").hide();
      $('.ipl-map .filter-summary .view-filter-summary').show();
    }

    // update list filter summary
    listFilterSummaryNo.text(projectNo);
    listFilterSummaryList.text(allSelectedFilter);
    listFilterFacetItemList.text(allSelectedFacetItems);

    updateListPager();
  }

  function hasSameElement(array1, array2) {
    let isInArray = false;
    array1.forEach(function(item, index) {
      isInArray = isInArray || array2.includes(item);
    });
    return isInArray;
  }

  function updateListPager() {

    let projectNo = 0;
    mapListViewSearchContent.each(function() {

          $(this)
            .closest('.views-row')
            .removeClass('hidden')
            .attr('data-page', Math.floor(projectNo / projectsShownOnPage) + 1);
          projectNo++;
      
    });

    let allSelectedFilter = '';
    let allSelectedFacetItems = '';
    let searchContentAndTags = '';
    // $('li.facet-item input.facets-checkbox').each(function() {
    //   if (searchResult ==''){
    //   if ($(this).attr('checked') == 'checked') {
    //     const filterValue = $(this)
    //       .next()
    //       .find('span')
    //       .text();
    //     allSelectedFilter == ''
    //       ? (allSelectedFilter += filterValue)
    //       : (allSelectedFilter += ', ' + filterValue);
    //   }
    // }else {
    //     if ($(this).attr('checked') == 'checked') {
    //       const filterValue = $(this)
    //         .next()
    //         .find('span')
    //         .text();
    //       searchContentAndTags= '"' + searchResult + '"' + ', ' + filterValue;
    //       allSelectedFilter == ''
    //         ? (allSelectedFilter += searchContentAndTags)
    //         : (allSelectedFilter += ', ' + filterValue);
    //   }
    // }
    // });
    // if (searchResult !=='' && allSelectedFilter == ''){
    //   allSelectedFilter = '"' + searchResult + '"';
    // }
    // if (allSelectedFilter == '') {
    //   allSelectedFilter = 'All';
    // }
        if (searchResult ==''){
        allSelectedFilter == '';
    }else {
        allSelectedFilter =  '"' + searchResult.replace(/\s+/g, '" "') + '"' ;
    }
    if (allSelectedFilter == '') {
      allSelectedFilter = 'Nil';
    }

    $('li.facet-item input.facets-checkbox').each(function() {
      if ($(this).attr('checked') == 'checked') {
        const filterValue = $(this)
          .next()
          .find('span')
          .text();
        allSelectedFacetItems == ''
          ? (allSelectedFacetItems += filterValue)
          : (allSelectedFacetItems += ', ' + filterValue);
     }
    });

    if (allSelectedFacetItems == '') {
      allSelectedFacetItems = 'All';
    }
    // update list filter summary
    listFilterSummaryNo.text(projectNo);
    listFilterSummaryList.text(allSelectedFilter);
    listFilterFacetItemList.text(allSelectedFacetItems);

    if (allSelectedFilter !== 'Nil' || allSelectedFacetItems !=='All'){
      var filtersBlock =  $('#filters-search');
      $('#views-exposed-form-ipl-database-search-ipl-map-db-search #edit-actions--3').before(filtersBlock);
      $('#filters-search').removeClass("hidden");
    }

    // Update the pager
    const totalProject = $('.list-view .views-row:not(.hidden)').length;
    const totalPage = Math.floor((totalProject - 1) / projectsShownOnPage + 1);

    mapListViewContent.attr('data-page', 'page-1');
    mapListViewPagerUl.empty();

    if (totalPage > 1) {
      mapListViewPagerUl.append(
        '<li class="pager__item pager__item--previous"><a tabindex="0"><span>Prev</span></a></li>'
      );
      for (let i = 1; i <= totalPage; i++) {
        let isActive = '';
        if (i == 1) {
          isActive = 'is-active';
        }
        mapListViewPagerUl.append(
          '<li class="pager__item ' +
            isActive +
            '" data-page="' +
            i +
            '"><a tabindex="0"><span>' +
            i +
            '</span></a></li>'
        );
      }
      mapListViewPagerUl.append(
        '<li class="pager__item pager__item--next clickable"><a tabindex="0"><span>Next</span></a></li>'
      );
    }

    updateListPagerDisplay();
  }

  function updateListPagerDisplay() {
    mapListViewPager.find('.pager__item').removeClass('shown');
    if (
      !mapListViewPager
        .find('.is-active')
        .prev()
        .hasClass('pager__item--previous')
    ) {
      mapListViewPager
        .find('.is-active')
        .prev()
        .addClass('shown');
    }
    if (
      !mapListViewPager
        .find('.is-active')
        .next()
        .hasClass('pager__item--next')
    ) {
      mapListViewPager
        .find('.is-active')
        .next()
        .addClass('shown');
    }
  }

  function updateListViewClearAllButtonStatus() {
    if (
      $('.map-filter input.facets-checkbox[checked="checked"]').length ||
      $('#list-search-key').val()
    ) {
      mapClearAllButton.find('input').removeAttr('disabled');
    } else {
      mapClearAllButton.find('input').attr('disabled', 'disabled');
    }
  }

  function disableAllState() {
    $('.state-filter li.facet-item:not(:first)')
      .addClass('disabled')
      .find('input')
      .removeAttr('checked');
  }

  function enableAllState() {
    $('.state-filter li.facet-item:not(:first)').removeClass('disabled');
  }

  function resetStateFilter() {
    $('.state-filter input').removeAttr('checked');
    enableAllState();
  }

  function disableRegionFilter() {
    $('.region-filter')
      .addClass('disabled')
      .find('.facets-widget-checkbox__selector')
      .attr('tabindex', '-1');
    $('.region-filter li.facet-item').hide();
  }

  function enableRegionFilter() {
    $('.region-filter')
      .removeClass('disabled')
      .find('.facets-widget-checkbox__selector')
      .attr('tabindex', '0');
  }
});
